import React from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Buffer } from 'buffer';

const EventDialog = ({ open, handleClose, selectedEvent, sliderValue, setSliderValue }) => {
  if (!Array.isArray(selectedEvent) || selectedEvent.length === 0) {
    console.warn('selectedEvent is empty or not an array.');
    return null;
  }
  const currentEvent = selectedEvent[sliderValue];

  const handleNext = () => {
    if (sliderValue < selectedEvent.length - 1) {
      setSliderValue(sliderValue + 1);
    } else {
      handleClose();
    }
  };

  const handleBack = () => {
    if (sliderValue > 0) {
      setSliderValue(sliderValue - 1);
    }
  };

  return (
      <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: '#F1F1F1',
            borderRadius: '12px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            width: { xs: '90%', sm: '500px', md: '700px' },
            height: { xs: 'auto', md: '570px' },
            maxWidth: 'none',
            p: { xs: 2, md: 3 },
          },
        }}
      >
      {/* <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 'bold',
          fontSize: { xs: '1rem', md: '1.8rem' },
          color: '#136CB5',
        }}
      >
        Special Event Announcement
        <IconButton onClick={handleClose} sx={{ color: '#136CB5' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle> */}
      <DialogContent
        sx={{
          overflowY: 'auto',
          // maxHeight: '90vh',
          textAlign: 'center',
          p: { xs: 2, md: 3 },
        }}
      >
        <Box>
           <Box
        sx={{
          height: { xs: '180px', sm: '250px', md: '350px' },
          width: '100%',
          // overflow: 'hidden',
            overflowY: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '8px',
          border: '3px solid #136CB5',
          mb: { xs: 2, md: 3 },
        }}
      >
        <img
              src={
                currentEvent.events_photo
                  ? `data:image/${currentEvent.imageFormat || 'jpeg'};base64,${Buffer.from(
                      currentEvent.events_photo
                    ).toString('base64')}`
                  : '/path/to/default-image.jpg'
              }
              alt={currentEvent.events_title || 'Event Image'}
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
    </Box>    
      {/* Event Title */}
      <Typography
        variant="h5"
        sx={{
          mt: { xs: 1, md: 2 },
          fontWeight: 'bold',
          fontSize: { xs: '1rem', sm: '1.2rem', md: '1.6rem' },
          color: '#136CB5',
          wordBreak: 'break-word',
        }}
      >
        {currentEvent.events_title}
      </Typography>
          {/* Event Date */}
      <Typography
        variant="subtitle1"
        sx={{
          mt: 0.5,
          fontSize: { xs: '0.9rem', md: '1.1rem' },
          color: '#49BBBD',
        }}
      >
        {currentEvent.events_date}
      </Typography>

      {/* Event Details */}
      <Typography
        variant="body1"
        sx={{
          mt: 2,
          fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
          px: { xs: 1, sm: 2, md: 4 },
          textAlign: 'justify',
          color: '#333',
        }}
      >
        {currentEvent.events_detail}
      </Typography>
    </Box>

    {/* Buttons */}
    <DialogActions
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: { xs: 'center', sm: 'space-between' },
        alignItems: 'center',
        mt: { xs: 3, md: 4 },
        gap: { xs: 1.5, sm: 3 },
      }}
    >
      <Button
        onClick={handleBack}
        sx={{
          background: 'linear-gradient(90deg, #136CB5 0%, #49BBBD 100%)',
          color: 'white',
          width: { xs: '80%', sm: 'auto' },
          fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
          px: { xs: 2, sm: 3 },
          py: { xs: 1, sm: 1.2 },
          '&:hover': {
            background: 'linear-gradient(90deg, #49BBBD 0%, #136CB5 100%)',
          },
        }}
        disabled={sliderValue === 0}
      >
        Back
      </Button>

      <Button
        onClick={handleNext}
        sx={{
          background: 'linear-gradient(90deg, #136CB5 0%, #49BBBD 100%)',
          color: 'white',
          width: { xs: '80%', sm: 'auto' },
          fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
          px: { xs: 2, sm: 3 },
          py: { xs: 1, sm: 1.2 },
          '&:hover': {
            background: 'linear-gradient(90deg, #49BBBD 0%, #136CB5 100%)',
          },
        }}
      >
        {sliderValue < selectedEvent.length - 1 ? 'Next' : 'Close'}
      </Button>
    </DialogActions>
  </DialogContent>
</Dialog>

  );
};

export default EventDialog;








